import axios from 'axios'
import { REFRESH_TOKEN_ENDPOINT, REFRESH_TOKEN_KEY, TOKEN_KEY } from 'app/util/consts';
import { sleep, saveCookie, getCookie, getStaticDataUrl } from 'app/util/utils';

const api = axios.create({
    baseURL: process.env.REACT_APP_BASE_URL
});

api.interceptors.request.use(
    (config) => {
        const token = getCookie(TOKEN_KEY);
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    });

api.interceptors.response.use(
    response => {
        return response
    },
    async error => {
        const originalRequest = error.config;
        if (error.code == "ERR_NETWORK") {
            return Promise.reject(error);
        }
        if (error.response.status === 401 && !originalRequest._retry && originalRequest.url != "/user/refresh-token" && getCookie(REFRESH_TOKEN_KEY)) {

            originalRequest._retry = true;
            const res = await api.post('/user/refresh-token', { refreshToken: getCookie(REFRESH_TOKEN_KEY) })

            if (res.status === 200) {
                /* 1) put token to LocalStorage */
                saveCookie(TOKEN_KEY, res.data.accessToken, 1);
                saveCookie(REFRESH_TOKEN_KEY, res.data.refreshToken, 14);

                /* 2) Change Authorization header */
                const token = res.data.accessToken
                api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

                /* 3) return originalRequest object with Axios. */
                return api(originalRequest);
            } else {
                return Promise.reject(error);
                // await router.replace({ path: '/login', query: { fallBackUrl: encodeURIComponent(urlPath) } })
            }
        }
        else {
            return Promise.reject(error);
            // await router.replace({path:'/login',query:{fallBackUrl:encodeURIComponent(urlPath)}})
        }
    });

export default api;
export { axios }